<template>
    <form-accordion
        name="transaction-notes"
        section="Transaction Notes"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <div class="pt-6">
            <input-textarea
                name="notes"
                v-model="property.deal.notes"
            />
        </div>
    </form-accordion>
</template>

<script>
export default {
    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
